export default "__VITE_ASSET__sjdNxfnA__"